export var themeTokens5_4 = {
  clearCrossIconWidthSmall: '24px',
  clearCrossIconWidthMedium: '30px',
  clearCrossIconWidthLarge: '36px',
  clearCrossIconAlign: 'flex-start',
  textareaMargin: '0px',
  // обнуление вертикального браузерного margin в firefox
  textareaVerticalAlign: 'top'
};